
export enum ERole {
    Standard,
    Admin,
    Observer,
}